import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import type { UsageData } from '@/features/customers/types/customerDetail.types'

interface UsageChartProps {
  data: UsageData[]
  title?: string
  height?: number
}

export function UsageChart({
  data,
  title = '',
  height = 300,
}: UsageChartProps) {
  return (
    <div className='space-y-4'>
      <h3 className='text-lg font-semibold'>{title}</h3>
      <ResponsiveContainer width='100%' height={height}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis
            dataKey='date'
            tick={{ fontSize: 12 }}
            tickFormatter={value => {
              const date = new Date(value)
              return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
              })
            }}
          />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip
            labelFormatter={value => {
              const date = new Date(value as string)
              return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              })
            }}
            formatter={
              ((value: number, name: string) => {
                const formatValue =
                  name === 'cost' || name === 'revenue'
                    ? `$${value.toFixed(2)}`
                    : value.toLocaleString()
                return [
                  formatValue,
                  name.charAt(0).toUpperCase() + name.slice(1),
                ]
              }) as never
            }
          />
          <Legend />
          <Line
            type='monotone'
            dataKey='tasks'
            stroke='#475569'
            strokeWidth={2}
            name='Tasks'
            dot={{ r: 3 }}
            activeDot={{ r: 5 }}
          />
          <Line
            type='monotone'
            dataKey='workflows'
            stroke='#64748b'
            strokeWidth={2}
            name='Workflows'
            dot={{ r: 3 }}
            activeDot={{ r: 5 }}
          />
          <Line
            type='monotone'
            dataKey='outcomes'
            stroke='#334155'
            strokeWidth={2}
            name='Outcomes'
            dot={{ r: 3 }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
